export enum LogLabel {
  AppError = 'AppError',
  AppRouteError = 'AppRouteError',
  AppStartUpError = 'AppStartUpError',
  ErrorBoundary = 'ErrorBoundary',
  ErrorBoundaryWithFallback = 'ErrorBoundaryWithFallback',
  FeedbackPromptError = 'FeedbackPromptError',
  FollowPropertyError = 'FollowPropertyError',
  HeadersAlreadySentError = 'HeadersAlreadySentError',
  MembersFeedbackModalWithDataError = 'MembersFeedbackModalWithDataError',
  NodeProcessUncaughtException = 'NodeProcessUncaughtException',
  OptimizelyTimeoutError = 'OptimizelyTimeoutError',
  UnknownError = 'UnknownError',
  UrqlCSRClientError = 'UrqlCSRClientError',
  UrqlSSRClientError = 'UrqlSSRClientError',
  UrqlSuccessAfterErrorRetry = 'UrqlSuccessAfterErrorRetry',
}
